import React, { forwardRef } from "react";

import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import CartIcon from "@/components/icons/CartIcon";
import Link from "next/link";
import CartDropDownItem from "./CartDropDownItem";
import CurrencyIcon from "@/components/icons/CurrencyIcon";

const CartDropDown = ({ items, cartTotal, onHide }, ref) => {
  const { t } = useTranslation("common");
  const { pathname, push } = useRouter();

  return (
    <div
      ref={ref}
      className="absolute max-h-[450px] overflow-y-auto primary-scrollbar top-full -end-4 bg-white shadow p-4 pb-0 rounded-md z-[200] w-[350px] text-black"
    >
      {(items || [])?.length ? (
        <>
          <ul className="max-h-[280px] overflow-y-auto primary-scrollbar">
            {(items || []).map((product, i) => (
              <CartDropDownItem key={i} product={product} />
            ))}
          </ul>
          <div className="flex items-center justify-center gap-5 my-2">
            <span className="font-semibold">{t("Sub Total")} </span>
            <span className="flex items-center gap-1 font-bold">
              {cartTotal} <CurrencyIcon className="size-3.5" />
            </span>
          </div>
          <button
            onClick={() => {
              push("/cart");
              onHide();
            }}
            className="p-1.5 border  font-semibold rounded-md w-full mb-3"
          >
            {t("View and Edit My Cart")}
          </button>
          <button
            onClick={() => {
              push("/checkout");
              onHide();
            }}
            className="p-1.5 border border-tertiary-800 text-white bg-tertiary-800 font-semibold rounded-md w-full mb-3"
          >
            {t("Checkout")}
          </button>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center gap-4 p-4">
          <CartIcon size={48} className="text-slate-300" />
          <span className="text-tertiary-800">{t("No Items in Cart")}</span>
          {pathname !== "/" ? (
            <Link
              href="/"
              className="block w-full p-2 mb-2 text-center text-white transition-colors duration-300 rounded-md bg-tertiary-800 hover:bg-red-400"
            >
              {t("Continue shopping")}
            </Link>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default forwardRef(CartDropDown);
